export default {
  // 导航
  app_nav: {
    businessManage: '系统管理',
    membersManage: '成员管理',
    roleManage: '角色管理',
    customApp: '自定义应用',
    safeManage: '安全管理',
    interfaceIntegratio: '接口集成',
    appCenter: '应用中心',
    recycleBin: '回收站',
    personalSetting: '个人设置',
    platformTemplate: '平台模版',
    noAuth: '您没有权限访问该模块',
    accountCenter: '组织管理',
    applicationManagement: '应用管理',
    cloudDevelop: '云开发',
    dataCenter: '数据中心',
    taskMonitoring: '自动化任务监控',
    systemTemplate: '系统模版'
  },
  // 企业管理
  business_management: {
    manageHomepage: '管理首页',
    basicmodule: '基础模块',
    businessManage: '系统管理',
    businessSet: '系统设置',
    businessWorkflow: '机构工作流',
    welcome: '欢迎使用，您现在所在的是',
    managebackstage: '的管理后台',
    currentVersion: '当前版本',
    versionInfo: '版本信息',
    closingDate: '截止日期',
    systemVersion: '系统版本',
    accountUsage: '账号使用情况',
    accountNum: '账户数',
    spaceUsage: '空间使用情况',
    space: '空间',
    dataUsage: '数据量使用情况',
    dataNum: '数据量',

    upgrade: '升级',
    additional: '增购',
    remainingavailable: '剩余可用',
    purchasedusersnumber: '已授权用户数',
    usedusersnumber: '已使用用户数',
    remainingdays: '剩余天数',
    starttime: '开始时间',
    endtime: '结束时间',
    totaldataavailable: '可使用数据总量',
    totalamountdataused: '已使用数据总量',
    totalattachmentspace: '附件空间总数',
    attachmentspaceused: '已使用附件空间',
    cleardeletedfiles: '一键清除已删除文件',
    consumptionsituation: '消费情况',
    applyforinvoice: '申请开票',
    contractinformationperfect: '合同信息完善',
    typeofbusiness: '业务类型',
    ordernumber: '订单号',
    orderstatus: '订单状态',
    tobepaid: '待支付',
    paymentsuccessful: '支付成功',
    cancelorder: '取消订单',
    paymenttime: '付款时间',
    orderamount: '订单金额',
    paymenttype: '支付类型',
    wechat: '微信',
    alipay: '支付宝',
    contractdownload: '合同下载',
    organizeinformation: '组织信息',
    fullorganizationname: '组织全称',
    organizespecificaddress: '组织具体地址',
    zipcode: '邮政编码',
    emailaddress: '电子邮箱',
    contactname: '联系人姓名',
    mobilenumber: '手机号码',
    fax: '传真',
    additionalorders: '增购订单',
    additionalpurchasetype: '增购类型',
    increaseaccountnumber: '增加账户数',
    companyname: '机构名称',
    contractpreview: '合同预览',
    continuelongtime: '续费时长',
    durationofuse: '使用时长',
    expandedquantity: '扩充数量',
    numberofpackages: '套餐数量',
    expansionspace: '扩充空间',
    paymentamount: '付款金额',
    companypackageendtime: '机构套餐结束时间',
    paymentamountcalculate: '付款金额=（套餐结束时间-当天时间）*合同帐户单价',
    methodofpayment: '支付方式',
    paynow: '立即支付',
    payTip1: '系统在收到款项支付后自动生成续费订单续费订单并完成续费服务。',
    payTip2: '如果您已完成付款而未成功续费，请拨打免费咨询热线',
    teamfacecashier: '收银台',
    scanpayment: '扫一扫付款（元）',
    turnonphonewechat: '打开手机微信',
    scancompletepayment: '扫一扫完成支付',
    pay: '支付',
    completepayment: '完成支付',
    youcanchoose: '您可以选择',
    gototheadminhomepagetoviewconsumption: '到管理首页查看消费情况',
    paymentfailed: '支付失败',
    suggestyouselect: '建议您选择',
    reorderpayment: '重新下单支付',
    renewal: '续费',
    expansionseat: '扩充坐席',
    expandeddataaggregate: '扩充数据总量',
    expandeddata: '扩充数据',
    totaldatacharge: '充数据总量',
    expandedseats: '扩充席位',
    upgradedversion: '升级版本',
    order_amount_error: '订单金额异常',
    company_full_name_error: '组织全称不能为空',
    company_address_error: '组织具体地址不能为空',
    email_empty: '电子邮箱不能为空',
    email_error: '电子邮箱格式错误',
    contact_name_error: '联系人姓名不能为空',

    modifyEnterpriseName: '修改机构名称',
    modifyEnterpriseTip:
      '修改当前机构信息后，涉及的相关地方将全部被更新替换，建议不要频繁的修改机构信息，以免机构成员不能正常识别。',
    enterpriseAdress: '机构地址',
    modifyEnterpriseAdress: '修改机构地址',
    modifyEnterpriseTip2: '不同部门可以使用不同的机构地址。',
    addAddress: '添加机构地址',
    continueaddAddress: '继续添加机构地址',
    editentErpriseLogo: '修改机构LOGO',
    logoTip: '建议上传PNG透明无底色反白logo，240*70大小的PNG图片;    大小不超过1M；',
    updateLogo: '上传logo',
    modifylocalDomainAddress: '修改本地化的域名地址',
    domainAddressTip: '修改本地化的域名地址，用于与认证平台建立链接，保障机构能正常使用本系统。',
    domainAddressTip2: '请输入花生壳域名或公网IP（包含端口且必填）',
    modifylocalIMaddress: '本地IM地址',
    imAddressTip: '可修改IM地址，请输入正确的IP地址，用于企信的使用。',
    appBannerSet: '移动端Banner设置',
    updateTip: '建议上传JPG格式图片，1035*420大小的PNG图片、最多上传5张;    每张大小不超过1M；',
    updateBanner: '上传Banner',
    languageSelect: '语言选择',
    setLanguageType: '设置平台的语言类型',
    chinese: '简体中文',
    traditional: '繁体中文',
    english: '英语',
    transferEnterprise: '平台负责人',
    transferEnterpriseTip:
      '如果你不想再管理当前平台机构，你可以选择转让给机构中的其他成员，转让之后你将无法在管理当前平台机构，并且该操作无法撤销。',
    selectOwner: '选择负责人',
    loginPwd: '登录密码',
    inputCurrentPwd: '输入当前账号密码',
    enterpriseName: '机构名称',
    enterpriseName_empty: '机构名称不能为空',
    domain_empty: '域名地址不能为空',
    adress_error: '地址格式不正确',
    maxImages5: '最多上传5张图片',
    image_empty: '请上传图片',
    imageSize: '每张图片大小不超过1M',
    owner_empty: '平台负责人不能为空',
    imageFormat: '请上传PNG或JPG图片',
    imageLimit: '图片超过上传限制',
    inputAddress: '请输入机构地址',
    pleaseSelectDepartment: '请选择部门',
    departmentalDuplication: '部门重复；请重新选择',
    billManage: '账单管理',
    SMSManage: '短信管理',
    addWorkflow: '新建工作流',
    userMember: '使用人员',
    workflowName: '工作流名称',
    addMember: '添加成员',
    workflowDesc: '工作流描述',
    inputContent1000: '请输入内容，限制1000个字',
    inputWorkflowName25: '请输入工作流名称，限制25个字',
    workflowNameNotEmpty: '工作流名称不能为空',
    sureDelWorkflow: '确定要删除该工作流吗?',
    addContion: '添加条件',
    resetWorkflowDelInfo: '重置后流程会恢复初始化样式，已设置好的工作流会被还原。你确定要重置吗？',
    binding: '绑定',
    accountBinding: '账户绑定',
    sendManage: '发送管理',
    signtrue: '签名',
    accountBindingMsg1:
      '使用短信前，先在对应的短信平台注册账户，注册成功后将 AppKey 和 Master Secret 填写到系统中进行绑定',
    accountBindingMsg2: '短信平台',
    accountBindingMsg3: '发送短信状态回调',
    accountBindingMsg4:
      '用于审批失败时获取失败原因，在极光系统的【短信设置】中将URL复制到“下行消息发送状态回调设置”中',
    accountBindingMsg5: '模版审核状态回调',
    accountBindingMsg6:
      '用于审批失败时获取失败原因，在极光系统的【短信设置】中将URL复制到“模版审核结果回调”中',
    accountBindingMsg7: '签名审核状态回调',
    accountBindingMsg8:
      '用于审批失败时获取失败原因，在极光系统的【短信设置】中将URL复制到“签名审核结果回调”中',
    accountBindingMsg9: '在极光系统中的【应用设置】-【应用信息】中可查找到',
    AppKeyNotEmpty: 'AppKey不能为空',
    MasterNotEmpty: 'Master Secret不能为空',
    sendContent: '发送内容',
    downAll: '下载全部',
    failReason: '失败原因',
    sending: '发送中',
    sendSuccess: '发送成功',
    sendFail: '发送失败',
    sendStatus: '发送状态',
    sendCount: '发送数量',
    receiveMunber: '接收号码',
    sendTiem: '发送时间',
    allInfo: '全部信息',
    signtrueName: '签名名称',
    signtrueType: '签名类型',
    documentaryEvidence: '证明文件',
    documentaryEvidenceInfo: '文件支持 PNG、JPG、JPEG 格式，且大小不超过 2M',
    applicationNotes: '申请说明',
    name: '名称',
    nameInfo: '长度显示2-8个字符，无需添加【】',
    uploadFile: '上传文件',
    signtrueTypeInfo1: '机构名称全称或简称',
    signtrueTypeInfo2: '需提供营业执照',
    signtrueTypeInfo3: '工信部备案的网站全称或简称',
    signtrueTypeInfo4: '需提供主办单位的营业执照',
    signtrueTypeInfo5: 'APP应用全称或简称',
    signtrueTypeInfo6: '需提供任一应用商店的下载链接及开发者的营业执照',
    signtrueTypeInfo7: '公众号或小程序名称的全称或简称',
    signtrueTypeInfo8: '需提供公众号（小程序）主体营业执照',
    signtrueTypeInfo9: '电商平台店铺全称或简称',
    signtrueTypeInfo10: '需提供经营者营业执照',
    signtrueTypeInfo11: '商标名称全称或简称',
    signtrueTypeInfo12: '需提供商标注册证书',
    signtrueTypeInfo13: '其他',
    signtrueTypeInfo14: '需提所有者供营业执照',
    signtrueTypeInfo15: '请简略描述您的业务场景，不超过100字',
    nameMustfill: '名称必填',
    documentaryFlieNotEmpty: '证明文件不能为空',
    applicationNotesMustfill: '申请说明必填',
    sureDelFigntrue: '你确认要删除该签名吗?',
    determineDelete: '该签名下存在短信模版，请确认签名已无模版使用',
    picMax2M: '图片不得超过2MB',
    onlineApproval: '在线审批，高效直达',
    approvalType: '审批类型',
    dataQuery: '数据查询',
    startPer: '发起人',
    query: '查询',
    ModifyCurrentApprover: '修改当前审批人',
    currentApproverModufy: '将当前审批人员修改为指定人员',
    projectInfo: '可视化的组织工具，可以帮助您更快，更准确地管理和监督项目的开发',

    customLogin: '自定义登录设置',
    customLoginTip:
      '用户可以根据自己的个性化需求，定义平台登录方式、平台logo、机构风采、机构地址等。',
    enableCustomLogin: '启用自定义登录设计',
    loginAddress: '专属登录地址',
    loginAddress1: '请输入(至少6位，需字母开头)',
    corporateShowcase: '平台logo图',
    imagesTip: '支持jpg、gif、png格式，不超过5M图片',
    leftImage: '登录侧边主图',
    uploadPicture: '上传图片',
    reset: '重置',
    pictureSuggestedSize: '图片建议尺寸',
    pageBackground: '页面背景',
    backgroundColor: '背景颜色',
    backgroundPicture: '背景图片',
    fontColor: '字体颜色',
    loginMethod: '登录方式',
    automaticLoginOptions: '自动登录选项',
    check: '勾选',
    donotcheck: '不勾选',
    hide: '隐藏',
    display: '显示',
    registrationEntry: '注册入口',
    visitWebsite: '访问官网',
    websiteTip: '可输入机构官网地址',
    website_empty: '访问官网不能为空',
    weChatNote:
      '操作方法：将下方链接地址设置在公众号菜单中。( 注：微信需求本地化客户的地址端口必须用80或443端口，否则微信公众号不可通过地址访问系统。)',
    weChatPublicAccess: '微信公众号访问',
    weChatPublicAccount: '微信公众号',
    weChatPublicAccountContent: '通过微信公众号直接访问系统自定义模块',
    weChatPublicAccountName: '微信公众号名称',
    pushModule: '推送模块',
    setTemplateID1: '微信公众号消息推送设置',
    setTemplateID2:
      '通过微信公众号设置，系统将支持将消息推送至微信公众号，不填写及标识不需要推送消息至微信公众号。',
    setTemplateID3: '微信公众号消息模板ID',
    setTemplateID4:
      '进入微信公众号 后台 ->功能->添加功能插件处 申请模板消息功能，审批通过后可在列表中获得模块ID',
    loginFreeSettings: '免登录设置',
    loginFreeSettingsNote:
      '进入微信公众号后台，将微信公众号后台对应内容输入至系统中，可实现免登录；',
    nailingLink: '路径：钉钉开发平台-->应用开发-->H5微应用-->应用详情-应用信息下',
    nailingLink2: '路径：钉钉开发平台-->应用开发-->登录',
    nailingLink3: '钉钉开发平台-->基本信息-->开发信息（旧版）-->企业自用账号信息',
    autonomousApplication: '钉钉或企业微信-自主应用设置',
    autonomousApplicationTip:
      '设置后本地化客户可在钉钉或企业微信中进行使用，设置前请在钉钉或企业微信申请上传自主H5微应用。',
    nailing: '钉钉',
    enterpriseweChat: '企业微信',
    scanLogin: '扫码登录配置',
    weChatjsUrl:
      '进入微信公众号后台-->右上角头像-->功能设置-->功能设置-->JS接口安全域名行中点击设置-->弹窗中下载文件（事项3中有个文件点击下载）',
    weChatjsFile: 'JS接口安全域名文件',
    weChatjsFile_error: 'JS接口安全域名文件只支持txt文本文件',

    localdomainaddresssetting: '本地域名地址设置',
    solidcolor: '纯色',
    publicqrcodereplacement: '公众号二维码替换',
    uploadcompanyqrcodesofficialaccount: '上传机构的公众号二维码',
    title: '标题',
    qrcode: '二维码',
    uploadqrcodepicture: '上传二维码图片',
    publishapplication: '发布应用',
    webaddress: 'WEB地址',
    pcsidebackgroundconfiguration: 'PC端后台配置',
    receivingserveraddress: '接收服务器地址',
    enterpriseloginaddress_empty: '专属登录地址不能为空',
    enterpriseloginaddress_error: '专属登录地址只能存在英文与字母',
    bindingnailingconfirm: '确定要重新绑定钉钉吗？',
    bindingweChatconfirm: '确定要重新绑定企业微信吗？',
    enterpriseloginaddress_error2: '专属登录地址冲突',
    companyNumber: '机构编号',
    // 20201224
    enterprisedisplaychart: '背景展示图',
    // 20210305
    usercertificate: '使用证书',
    certificate: '授权证书',
    cloud: '云服务',
    local: '本地',
    upgradeTip: '使用该功能需要升级更高版本',
    upgradeAlert: '升级提醒',
    upgradeTip2: '尊敬的用户，使用该功能需要升级更高版本',
    enquiryHotline: '咨询热线',
    scanningconsulting: '扫码咨询升级服务',
    openconnection: '打开连接',
    submitupgraderequestonli: '在线提交升级需求',
    pgradeNow: '立即升级',
    versionUpgrade: '版本升级',
    selectversion: '选择版本',
    fit: '适合',
    customEdition: '定制版',
    customExclusiveVersion: '根据需求定制专属版本',
    payasyouwant: '按需付费',
    onDemand: '按需定制',
    applynow: '立即申请',
    renewalOrder: '续费订单',
    renewalPeriod: '续费年限',
    upgradedVersionOnly: '不续时间，仅升级版本',
    singleTotal: '单总计',
    accounerror: '账户数低于版本最低人数限制，请先增加账户数再进行版本升级',
    upgradeto: '升级为'
  },
  // 成员管理
  membership_management: {
    department: '部门',
    seachall: '搜索',
    disabledEmployee: '已停用的员工',
    jobManage: '职务管理',
    personCharge: '负责人',
    searchResult: '的搜索结果',
    addStaff: '添加员工',
    updateStaff: '上传员工',
    adjustDepartment: '调整部门',
    changeRole: '更换角色',
    addRoles: '追加角色',
    resetPwd: '重置密码',
    activationReminder: '激活提醒',
    addDepartment: '添加部门',
    departmentName: '部门名称',
    superiorDepartment: '上级部门',
    editDepartment: '编辑部门',
    departmentTip: '请确保删除的部门已无成员，若存在成员将删除失败。',
    confirmDeletion: '确定要删除“',
    departmentTip2: '”部门吗？',
    departmentTip3: '注意：审批流程和自定义设置可能存在调用，删除前请先调整设置。',
    pwdType: '密码类型',
    SMSpwd: '短信密码',
    manualInput: '手动输入',
    initializePwd: '初始化密码',
    subordinateDepartment: '所属部门',
    mainDepartment: '主部门',
    editMember: '编辑成员',
    owner: '平台负责人',
    setPersonCharge: '设置负责人',
    departmentStaff: '该部门员工',
    common: '共',
    activationTip: '提示：此项操作仅对未激活账号发送激活提醒短信。',
    confirmThe: '确定对选中的',
    activationTip2: '个员工账号激活提醒吗？',
    stopUsingTip: '提示：停用后，该账号将无法登录当前平台机构',
    stopUsingTip2: '个员工账号停用吗？',
    deleteTip: '你确定删除选中的账号吗？',
    enableTip: '提示：启用后，成员将可以继续登录系统。',
    enableTip2: '个员工启用吗？',
    postManage: '职务管理',
    addDuties: '添加职务',
    deleteTip2: '提示：删除后，职务将无法恢复，请谨慎操作。',
    deleteTip3: '你确定要删除此职务吗？',
    batchImportEmployee: '批量导入员工',
    selectFile: '选择文件',
    uploadStaff: '上传员工',
    clickDownload: '点击下载',
    employeeTemplate: '员工通讯录导入模版',
    templateTip: '上传填写正确的员工通讯录导入模版',
    matters: '注意事项',
    matterTip:
      '填写信息时注意不要修改表头名称,标为必填项的都需要填写。允许导入的文档格式为:xls、xlsx；一次导入条数不超过1000条且文件大小不能超过4M。如果导入的资料过多,时间会较长,请耐心等待。',
    pwd: '密码',
    department__empty: '部门名称不能为空',
    departmentLength: '部门名称不能超过25个字符',
    name_empty: '姓名不能为空',
    role_empty: '角色不能为空',
    mianDepartment_empty: '主部门不能为空',
    selectdepartment: '请选择部门',
    noInactiveMembers: '没有选中未激活的成员',
    noOperateOwner: '不能操作平台负责人',
    disabledEmployee2: '已停用员工',
    post_empty: '职位不能为空',
    uploadFormat_error: '上传格式错误',
    uploadResults: '上传结果',
    addChildDeppartment: '添加子部门',
    editDeppartment: '编辑部门',
    deleteDeppartment: '删除部门',
    organizationalstructure: '组织架构',
    addressbookisolation: '通讯录隔离',
    character: '角色',
    user: '用户',
    member: '成员',
    activation: '激活',
    unbindenterprisewechat: '解绑企业微信',
    synchronousorganizationarchitecture: '同步组织架构',
    departmentsettings: '部门设置',
    unstaple: '解绑钉钉',
    bindcomparisontable: '绑定对照表',
    entrydate: '入职日期',
    weChataccount: '企业微信账户',
    accountcorrespondingtable: '企业微信账户和本平台账户对应表',
    teamfaceaccount: '本平台账户',
    correspondingtableTip:
      '企业微信未对应成员将添加账户至本平台，对应成员将企业微信成员绑定本平台原账户。',
    unbindenterpriseweChatTip: '确定要解除与钉钉的绑定吗',
    unbindenterpriseweChatTip2:
      '解绑后，组织架构、成员、角色将允许维护。如需重新绑定，请至【系统管理】中设置重新绑定；',
    personnelOptionalConfig: '人员可选配置',
    personnelOptionalConfigRemark:
      '设置员工是否可配置接单开关，员工开启接单开关后才能被选中。',
    showReceiveOrderSwitch: '是否显示接单开关',
    showReceiveOrderSwitchTip: '选择“是”则在移动端我的页面显示接单开关',
    forceReceiveOrderSwitch: '是否强制接单开关开启',
    forceReceiveOrderSwitchTip: '选择“是”则接单开关强制开启，不可关闭',
    departmentOptionalConfig: '部门可选配置',
    addressbookisolationremark:
      '设置后将对隔离的部门在通讯录中进行隐藏/限制，自定义模块和固定模块都对应在人员组件和部门组件中受到该设置限制。',
    quarantinedepartment: '隔离部门',
    quarantinedepartmentRaio1: '是否对上面选中的部门在通讯录中隐藏',
    quarantinedepartmentRaio2: '是否对上面选中的部门在通讯录中限制查看详细信息',
    quarantinedepartmentsettings: '隔离部门设置',
    addmembersdepartmentsroles: '添加成员、部门、角色',
    quarantinedepartmentRaio3: '不隐藏',
    quarantinedepartmentRaio4: '对部门外隐藏，但部门内和上级部门的负责人需显示',
    quarantinedepartmentRaio5: '对部门外隐藏',
    quarantinedepartmentRaio6: '对部门外隐藏，且仅可查看自己',
    quarantinedepartmentRaio7: '不限制',
    quarantinedepartmentRaio8: '仅可查看本部门内成员',
    quarantinedepartmentRaio9: '仅可查看自己',
    departmentcannotbeempty: '部门不能为空',
    language: '语言',
    memberexpo: '成员导出',
    leaderDisplay: '负责人显示',
    avatardisplay: '头像显示',
    addedSubordinateOrganization: '新增下级组织',
    editOrganizationalInformation: '编辑组织信息',
    deletecurrentorganization: '删除当前组织',
    additionalPersonnel: '新增人员',
    relatedStaffDetails: '关联员工详情',
    selectatleastonefieldtomatch: '至少选择一个匹配对应字段',
    selectamoduleinfor: '选择一个模块展示个人资料信息',
    selectmodule: '选择模块',
    selectfieldtomat: '选择匹配字段',
    relatedStaffTip: '确定要清空关联员工详情信息吗？',
    // 20210526
    userNameLeastOneItem: '手机号码或电子邮箱或工号至少填一项',
    userNameLeastOneItem2: '手机号码或电子邮箱至少填一项',
    emid_error: '工号格式错误',
    // 20220412
    activeemployee: '在职员工',
    inactive: '未激活的',
    loginprohibited: '禁止登录',
    deactivated: '已停用',
    loginprohibitedTip:
      '勾选则代表当前人员为虚拟账户，不登录系统，但是会参与考勤机对接、薪酬计算等业务操作',
    batchSelectTip: '您同时勾选了“启用”和“停用”的人员，无法进行批量操作'
  },
  // 角色管理
  role_management: {
    addGroup: '新建分组',
    editGroup: '编辑分组',
    deleteGroup: '删除分组',
    addRole: '新增角色',
    deleteRole: '删除角色',
    editRole: '修改角色',
    editRole2: '编辑角色',
    copyRole: '复制角色',
    roleTip:
      '如需更换平台负责人，请到【系统管理】页面，点击【变更负责人】来更换所有者，设置完成后信息自动同步。',
    managemember: '管理成员',
    apply: '应用',
    module: '模块',
    dataJurisdiction: '数据权限',
    funJurisdiction: '功能权限',
    allSelect: '全选',
    oneselfData: '仅查看本人数据',
    departmentData: '查看本部门数据',
    companyData: '查看全机构数据',
    groupName: '分组名称',
    groupDeleteTip: '提示：删除后，该分组将无法恢复，请谨慎操作。',
    groupDeleteTip2: '您确定删除分组？',
    roleName: '角色名',
    roleGroup: '角色组',
    roleGroup2: '角色分组',
    describe: '描述',
    roleDeleteTip: '删除后，该角色将无法恢复，请谨慎操作。',
    roleDeleteTip2: '确定要删除该角色吗？',
    roleDeleteTip3: '注意：审批流程和自定义设置可能存在调用，删除前请先调整设置。',
    group_empty: '角色组名不能为空！',
    addGroupTip: '请先新建分组',
    role_empty: '角色名不能为空！',
    updateTip: '内容有更新，是否需要保存？',
    charactersettings: '角色设置',
    rolemember: '角色成员',
    businesspermissions: '业务权限',
    backgroundadministrationauthority: '后台管理权限',
    menuname: '菜单名称',
    permissions: '权限'
  },
  // 安全管理
  safe_management: {
    securitysetting: '安全设置',
    pwdPolicy: '密码策略',
    sessionSet: '会话设置',
    dataBackup: '数据备份',
    IPrestriction: 'IP限制',
    logManage: '日志管理',
    pwdvalidity: '用户密码有效期',
    pwdMinLength: '密码最小长度',
    pwdComplexity: '密码复杂性要求',
    pwdError: '密码输入错误',
    enableSMSauthentication: '次后启用手机短信验证',
    lockAccounts: '次后锁定帐户15分钟',
    resetPwd: '全员重置密码',
    resetMsg:
      '勾选保存后让机构所有成员立即从当前的登录设备中退出登录，重新登录成功后强制修改密码才可使用。',
    saveSet: '保存设置',
    automaticLogout: '长时间未操作后自动登出',
    automaticBackup: '本地自动备份',
    backupMsg1: '可以根据自己的数据安全需要，进行本地数据自动备份',
    every: '每',
    backupMsg2: '天系统在凌晨0点自动备份一次，且仅保留最新的5个备份文件。',
    manualBackup: '手动触发备份',
    backupName: '备份文件名称',
    dataReduction: '数据还原',
    reductionMsg: '若平台机构数据需要还原到以前的内容，可在此进行操作，请勿随意操作数据还原。',
    reduction: '还原',
    confirmReduction: '确认还原',
    reductionMsg2: '手动上传数据进行还原',
    addAttachment: '添加附件',
    dataMigration: '云端数据迁移',
    migrationMsg1: '将云端备份的文件在此地进行迁移，见云端的系统迁移至本地。',
    updateFile: '上传数据文件',
    confirmCoverage: '确认覆盖',
    cloudBackup: '云端备份',
    cloudBackupMsg:
      '可以根据平台机构的数据安全需要，进行云端数据备份。若需要将云端数据迁移至本地服务器，请下载，下载后在新服务器中重新注册，注册时用云端注册的机构名称和手机号码，然后进入到【系统设置 - 系统管理】的“数据还原”中上传备份文件进行还原',
    reductionTip1: '确定要还原吗？',
    reductionTip2: '注意：还原后系统将按还原文件执行，请勿随意操作。',
    reductionTip3: '真的要还原吗？',
    reductionTip4: '请再次确认，确认后将执行还原。',
    backupSuccess: '您的备份已经成功，请到【安全管理】--【数据备份】中获取',
    ipLimitTip: 'IP设置默认针对全员，白名单账号不受登录限制：',
    whiteList: '白名单',
    ipLimitTip2: '限制机构全员仅在以下IP登录：',
    addIP: '添加IP',
    addIPSegment: '添加IP段',
    loginIP: '登录IP',
    addPeople: '添加人',
    loginTime: '登录时间',
    addLoginIP: '添加登录IP',
    ipTip1: '为了保证平台信息更加安全',
    ipTip2:
      '为了保证平台信息更加安全，平台负责人可以设置登录IP限制规则。设置后，只能在限制的IP下才可以登录。',
    ipTip3: '如',
    unlimited: '无限制',
    ipLimit1: '包含字母和数字字符',
    ipLimit2: '包含字母、数字和特殊字符',
    ipLimit3: '包含数字和大小写字母',
    ipLimit4: '包含数字、大小写字母和特殊字符',
    AddressDuplication: 'ip地址重复',
    ipFormatError: 'ip格式错误',
    ip_empty: '设置ip不能为空',
    backupTip:
      '已经开始备份，因备份时间过长，您可以先去完成其他工作，等备份完成后会将备份文件显示出来。',
    backupDay_empty: '请输入备份天数',
    backupDayLength: '请输入1~100的整数',
    oneYear: '一年',
    operationLog: '操作日志',
    loginLog: '登录日志',
    operator: '操作人',
    operationTime: '操作时间',
    operationContent: '操作内容',
    remark: '备注',
    createtime: '创建时间',
    ipstartingaddress: 'IP开始地址',
    ipendaddress: 'IP结束地址',
    ipstartingaddresscannotbenull: 'IP开始地址不能为空',
    incorrectipstartaddressformat: 'IP开始地址格式错误',
    incorrectipaddressformat: 'IP地址格式错误',
    useractionlog: '用户操作日志',
    backendoroperationslog: '后台管理员操作日志',
    menu: '菜单',
    behavior: '行为',
    username: '用户名',
    androidclient: 'Android客户端',
    iosclient: 'IOS客户端',
    windowsclient: 'Windows客户端',
    macclient: 'Mac客户端',
    ipaddress: 'IP地址',
    accountpasswordlogin: '账号密码登录',
    mobilephonescancodetologin: '手机扫码登录',
    ADdomainLogin: 'AD域登录',
    loginstatus: '登录状态',
    loginsuccessful: '登录成功',
    loginfailed: '登录失败',
    ipendaddressformat: 'IP结束地址格式错误',
    devicetype: '设备类型',
    basic_workbench: '基础模块-门户管理',
    basic_project: '基础模块-协作',
    basic_email: '基础模块-邮件',
    basic_approval: '基础模块-审批',
    basic_filelibrary: '基础模块-文件库',
    basic_repository: '基础模块-知识库',
    basic_attendance: '基础模块-考勤',
    basic_salary: '基础模块-薪酬',
    // 20210601
    enableSMSauthentication2: '次后启用手机短信/邮箱验证'
  },
  // 接口集成
  interface_integration: {
    interface: '接口',
    serviceInterface: '服务接口',
    address: '地址',
    interfaceSpecification: '接口说明',
    secretKey: '密钥',
    reset: '重 置',
    pwd: '密码',
    resetTip:
      '注：Authtoken和API密钥是重要的接口调用凭证，请注意保密！如不慎泄密，请立即重置，重置后将新API密钥发送给接口调用方修改凭证！',
    customInterface: '自定义接口',
    thirdPartyInterface: '第三方接口',
    pluginDownload: '插件下载',
    downloadPlugin: '下载插件',
    useResumeParsingInterface: '使用简历解析接口，请先',
    installPlugIns: '安装插件',
    setRule: '设置规则',
    receiveResumeModule: '接收简历模块',
    recognitionField: '识别字段',
    moduleField: '模块字段',
    valueMapping: '的值映射为',
    value: '的值',
    tip1: '一键导入各大招聘网站的被动求职者，省去一系列繁琐的操作。',
    clickHere: '【点击这里】',
    downloadPluginTip: '下载插件，按照步骤手动安装。',
    lunboTip1: '① 解压缩文件: 下载文件并解压',
    lunboTip2: '② 复制链接: 使用Chrome浏览器, 复制chrome://extensions并粘贴到地址栏, 按回车键',
    lunboTip3:
      '③ 拖拽文件夹: 拖拽解压后的文件夹至浏览器, 浏览器右上角将出现图标, 请勿将文件夹删除或改变路径',
    receivingResume: '接收简历模块不能为空',
    fieldSet: '字段设置不能为空',
    dataBase: '数据库',
    pleaseConnectToDatabase: '请先连接数据库',
    successfulConnection: '连接成功',
    unconnected: '未连接',
    customModule: '自定义模块',
    databaseForm: '数据库表单',
    modifier: '修改人',
    modificationTime: '修改时间',
    databaseConnectionSettings: '数据库连接设置',
    serverAddress: '服务器地址',
    portNumber: '端口号',
    databaseBame: '数据库名称',
    userName: '用户名',
    test: '测试',
    connectionFailed: '连接失败',
    saveTip: '连接成功才可以保存',
    interfaceType: '接口类型',
    changeTime: '变更时间',
    ruleCondition: '规则条件',
    fieldCorrespondence: '字段对应关系',
    customModuleFields: '自定义模块字段',
    databaseFormFields: '数据库表单字段',
    beCareful: '请注意：第一行为唯一约束ID，将作为数据变更后判断的条件。',
    dynamicValue: '动态值',
    fixedValue: '固定值',
    deleteTip: '确定要删除该数据吗？',
    readData: '读取数据',
    addData: '新增数据',
    editData: '编辑数据',
    deleteData: '删除数据',
    queryData: '查询数据',
    viewDetails: '查看详情',
    serverAddress_empty: '服务器地址不能为空',
    portNumber_empty: '端口号不能为空',
    portNumber_error: '端口号格式错误',
    dataBase_empty: '数据库不能为空',
    dataBaseNmae_empty: '数据库名称不能为空',
    userName_empty: '用户名不能为空',
    databaseForm_empty: '数据库表单不能为空',
    customModule_empty: '自定义模块不能为空',
    constraint_empty: '约束不能为空',
    integrate: '设置本系统与第三方平台系统接口集成',
    platform: '平台名称',
    ali: '阿里云',
    UFU8: '用友U8',
    kingdee: '金蝶',
    platform_empty: '平台名称不能为空',
    method: '请求方式',
    fieldName: '字段名称',
    fieldID: '字段ID',
    fieldType: '字段类型',
    fieldRequired: '是否必填',
    fieldExplain: '说明',
    explain: '请求示例',
    generateSignature: '生成签名',
    referenceFile: '引用文件',
    requestEncryption: '请求加密',
    local: '本机',
    publicNetwork: '公网',
    returnInstructions: '返回说明',
    requestFailure: '请求失败',
    requestSuccess: '请求成功',
    basicmodule: '基础模块',
    staff: '员工',
    requestHeader: '请求头',
    requestHeaderParameters: '请求头参数',
    requestAddress: '请求地址',
    staffList: '员工列表',
    stafDetail: '员工详情',
    departmentalList: '部门列表',
    departmentDetail: '部门详情',
    identityAuthentication: '身份认证',
    autograph: '签名',
    returnType: '返回的内容的类型；默认',
    option: '选项',
    aliCluster: '阿里云集成',
    alitilte: '人工智能插件',
    aliP1: '购买对应接口后，在“云市场-买家中心-进入管理控制台” 找到对应接口appCode。',
    aliAddress: '阿里云接口购买地址',
    payaccessto: '支付接入',
    openTip1: '开通后，可以使用支付宝支付，使用支付功能请在自定义组件数字或公式属性中开启。',
    openTip2: '开通后，可以使用微信支付，使用支付功能请在自定义组件数字或公式属性中开启。',
    setnow: '立即设置',
    openalipay: '开通支付宝',
    openwechatpay: '开通微信支付',
    openTip3: '请进入【支付宝】获取对应信息进行配置',
    openTip4: '请进入【微信后台】获取对应信息进行配置',
    operationmode: '操作方式',
    operationmodeTip1: '登录微信服务号后台-->微信支付-->产品中心-->AppID账号管理-->服务号的Appid',
    operationmodeTip2: '登录微信服务号后台-->微信支付-->账户中心-->个人信息-->登录账号',
    operationmodeTip3: '登录微信服务号后台-->微信支付-->账户中心-->API安全-->API密钥',
    alipaypay: '支付宝支付',
    wechatpay: '微信支付',
    doyouwanttounbind: '是否要解绑',
    unbindsuccessfull: '解绑成功',
    getSign: '获取签名',
    apiPwd: 'API秘钥',
    // 20210305
    sqldocking: '输入sql-对接系统',
    sqldocking2: '输入sql-本系统',
    maintableid: '主表ID',
    usedplugin: '已使用插件',
    uninstall: '卸载',
    allplugin: '所有插件',
    downloaded: '已下载',
    ssotip: '可免登陆访问其它关联系统',
    ssotip2:
      '通过单点登录，用户在系统工作台中可以实现一键登录到其他系统，不必要再次输入用户名/密码。',
    resumeanalysistip: '使用简历解析接口',
    backtoplugin: '返回插件管理',
    systemname: '系统名称',
    systemaddress: '系统地址',
    systemaddress_empty: '系统地址不能为空',
    authorizedUser: '授权用户',
    authorizedUser_empty: '授权用户不能为空',
    accountType: '账户类型',
    useTeamfaceaccount: '使用本平台账户',
    userentry: '用户录入',
    accountparametername: '账户参数名',
    accountparametername_empty: '账户参数名不能为空',
    passwordparametername: '密码参数名',
    passwordparametername_empty: '密码参数名不能为空',
    putitinmyapplist: '放入到我的应用列表',
    displayinportalcolumn: '放入门户栏目显示',
    openmode: '打开方式',
    newwindow: '新窗口',
    currentworkspace: '当前工作区',
    otherparameters: '其它参数',
    addparameters: '添加参数',
    parametername: '参数名称',
    parametervalue: '参数值',
    displayposition: '显示位置',
    ssoinfo:
      '单点登录（SSO），用户登录系统后，可免登陆访问系统中其他关联的系统应用即不需要再次输入帐户和密码即可访问其他系统应用，比如CRM、OA、ERP等，减少登录产生的时间消耗和帐户密码过多。',
    charge: '收费',
    pluginintroduce: '插件介绍',
    // 20210526
    dfmasaf: '数据库表单主子表关联字段',
    dfmasaf_empty: '数据库表单主子表关联字段不能为空',
    timeRepeat: '变更时间不能与修改时间重复',
    miniprogram: '小程序名片',
    miniprogramremark: '让客户第一时间了解我们',
    miniprogramnote: '一站式社交名片、产品橱窗、线索雷达的社会化营销平台',
    isenable: '是否启用',
    bindenterprises: '绑定机构',
    bindmodule: '绑定模块',
    showCardTip: '选择或新建一个模块展示名片访客信息',
    leastOneItem: '至少配置模块和一个字段',
    mapIntegration: '地图集成',
    bindBaiduAK: '绑定百度AK',
    bindBaiduAKInfo:
      '使用考勤定位和自定义组件.地图组件，都要绑定百度地图AK，请到百度地图中申请AK，如果没有绑定则不能允许地图定位功能；',
    bindGaoDeAK: '绑定高德AK',
    bindGaoDeClientAK: '客户端AK',
    bindGaoDeSecurity: '客户端密钥',
    bindGaoDeAKInfo:
      '使用考勤定位和自定义组件.地图组件，都要绑定高德地图AK，请到高德地图中申请AK，如果没有绑定则不能允许地图定位功能；',
    mapBaidu: '百度地图',
    mapGaoDe: '高德地图',
    mapSource: '地图源'
  },
  // 应用中心
  application_center: {
    recommend: '精品推荐',
    industryCategory: '行业分类',
    myUploads: '我的上传',
    serviceClassification: '业务分类',
    receiptsDetails: '收款明细',
    appIcon: '应用图标',
    appName: '应用名称',
    price: '价格',
    free: '免费',
    pay: '付费',
    uploader: '上传人',
    updataTime: '上传时间',
    state: '状态',
    yobeAudited: '待审核',
    notpass: '未通过',
    havePassed: '已通过',
    operation: '操作',
    details: '详情',
    auditOpinion: '审核意见',
    msg1: '确定要删除该应用吗？',
    msg2: '本操作只会在 “我的上传” 列表中删除，不影响该应用在其他模块的使用。',
    totalSum: '总金额',
    auditAmount: '审核金额',
    arrivalAccount: '到账金额',
    downNum: '下载次数',
    msg3: '很遗憾您上传的应用未能通过审核...',
    msg4: '您可以尝试按照以下（包括但不限于）修改意见来调整您的应用以便重新提交至审核。',
    team: '团队',
    auditIn: '审核于',

    industry: '行&nbsp;&nbsp;业',
    install: '安装',
    alreadyInstall: '已安装',
    onTrial: '试用',
    classify: '分&nbsp;&nbsp;&nbsp;&nbsp;类',
    price2: '价&nbsp;&nbsp;&nbsp;&nbsp;格',
    developer: '开发者',
    installNum: '安装次数',
    second: '次',
    score: '评分',
    moduleIntroduction: '模块介绍',
    moduleScreenshots: '模块截图',
    sweepingPayment: '扫一扫付款：',
    wechatpay: '打开手机“微信扫一扫”扫描二维码完成支付',
    aliipay: '打开手机支付宝扫描二维码完成支付',
    paymenCompleted: '完成支付',
    installSuccess: '安装成功',
    sweepCodePayment: '请先扫码付款',

    sizeInfo: '10条/页',
    expandMore: '展开更多',
    star: '星级',
    star_empty: '星级不能为空',
    comment_empty: '评论不能为空',
    send: '发送',
    // 20210305
    installation: '应用正在安装中，请稍后在自定义应用列表中查看',
    cost: '费用',
    customization: '定制',
    // 20220412
    iwantconsult: '我要咨询',
    scanningcodeconsultcustomerservice: '微信扫码咨询专业客服',
    experience: '体验一下',
    startapplication: '启动此应用',
    version: '所属版本',
    customizedscenesystem: '根据用户自身需求，定制符合业务场景使用的应用系统',
    Customizenow: '立即定制',
    installingapp: '正在安装应用…',
    contactadministratorinstall: '请联系系统管理员安装',
    industrySolutions: '行业方案'
  },
  // 回收站
  recycle_bin: {
    module: '模块',
    deletePerson: '删除人',
    deleteTime: '删除时间',
    reduction: '还原',
    emptyTrash: '清空回收站',
    msg1: '确定还原到删除之前的数据吗？',
    msg2: '确定要删除该数据吗？',
    msg3: '确定要清空回收站吗？',
    msg4: '删除后，数据将不可恢复',
    msg5: '清空后，数据将不可恢复',
    // 20220412
    hardDelete: '硬删除'
  },
  // 自动化任务监控
  task_monitoring: {
    selectForm: '选择表单',
    selectFormPlaceholder: '请选择表单',
    customNumber: '自定义编号',
    customNumberPlaceholder: '请输入自定义编号',
    ruleTitle: '规则名称',
    ruleTitlePlaceholder: '请输入规则名称',
    executeStatus: '执行状态',
    executeStatusPlaceholder: '请选择执行状态',
    executeStatusSucc: '执行成功',
    executeStatusFail: '执行失败',
    serialNumber: '序号',
    taskID: '任务ID',
    moduleName: '表单名称',
    ruleTriggers: '触发事件',
    ruleRemark: '规则描述',
    taskStartTime: '任务时间',
    taskExecutionRecord: '任务执行记录',
    nameOfTheExecutedOperation: '执行操作名称',
    operationDetail: '操作详情',
    operationName: '操作名称'
  },
  // 个人设置
  personal_setting: {
    basicSetup: '基本设置',
    updatePwd: '修改密码',
    oldPwd: '原密码',
    newPwd: '新密码',
    updateInfo:
      '修改密码时需要输入当前密码，如果你忘记了当前密码，可以在登录界面通过“忘记密码”功能来重置你的密码。',
    modifyPhone: '修改手机号码',
    currentmobile: '你当前的手机号码是',
    updatePhoneMsg: '，修改手机时系统会发送验证码到新的手机号码上，然后输入验证码后完成修改。',
    updatePhoneMsg2:
      '手机号码不但是个人通讯方式，而且还是系统的登录账号，如果不是更换手机建议不要随意修改手机号码，避免忘记登录账号。',
    newNumber: '输入新手机号码',
    phoneCode: '输入手机验证码',
    getcode: '获取验证码',
    exitSession: '退出会话',
    exitMsg:
      '如果你的手机丢失，为了防止其他人看到你的信息，可以从这里退出除了当前浏览器之外的所有会话。',
    headSculpture: '设置头像',
    headSculptureMsg: '可更换您的图片，图片将会自动生成三种尺寸，请注意更换后的图片是否清晰。',
    selectPhotos: '选择照片上传',
    photoMsg: '仅支持JPG,GIF,PNG格式上传且文件小于3M。',
    personal: '个人资料',
    personalMsg: '管理您的个人信息并更新姓名、性别、生日等设置。',
    updatePhotos: '上传头像',
    phoneCode_empty: '手机验证码不能为空',
    codehasbeensent: '验证码已经发送到该手机号码',
    retrieve: '后重新获取',
    name_empty: '姓名不能为空',
    pwdDifferent: '新密码与确认密码不相同',
    photoError: '请上传JPG,GIF,PNG格式的图片',
    filesize: '文件大于3M',
    oldPwd_empty: '原密码不能为空',
    basicInfo: '基本资料',
    thirdpartydataimprovement: '第三方绑定集成资料完善',
    perfectTip:
      '该设置仅在钉钉或企业微信集成模式且未输入手机号时显示，补充手机号和登录密码后，绑定钉钉和企业微信用户可以通过手机号+密码进行登录。',
    suretomodify: '当前手机号码存在于另一家机构，是否确定修改'
  }
}
